/* Generated from the behmn redesign front matter. */
export const BEHMN_PAGES = [
  {
    "route": null,
    "rel": "404",
    "pageKey": "404",
    "title": "Page not found · behmn",
    "description": "",
    "robots": "noindex",
    "nav": null,
    "bodyClass": "page-404",
    "css": [
      "404"
    ],
    "js": [],
    "head": null
  },
  {
    "route": "/case-study/glueiq",
    "rel": "case-study/glueiq",
    "pageKey": "case-study-glueiq",
    "title": "GlueIQ case study · behmn",
    "description": "How GlueIQ turned its existing AI talent into shared capability, six AI Game Day (hackathon) teams’ ideas into working products and workflows, and a live platform of its own.",
    "robots": null,
    "nav": null,
    "bodyClass": "page-case",
    "css": [
      "case-study"
    ],
    "js": [],
    "head": null
  },
  {
    "route": "/contact",
    "rel": "contact",
    "pageKey": "contact",
    "title": "Start a conversation · behmn",
    "description": "Book a discovery call with behmn, or email hello@behmn.com.",
    "robots": null,
    "nav": "contact",
    "bodyClass": "",
    "css": [
      "contact",
      "contact-human",
      "contact-firm"
    ],
    "js": [],
    "head": null
  },
  {
    "route": "/for-you",
    "rel": "for-you",
    "pageKey": "for-you",
    "title": "For you · behmn",
    "description": "You’ve got the tools. So does everyone you compete with. We work with you one on one, on your real work, until AI is just how you work.",
    "robots": null,
    "nav": "for-you",
    "bodyClass": "page-for-you",
    "css": [
      "for-you",
      "for-you-agency"
    ],
    "js": [
      "for-you-agency"
    ],
    "head": null
  },
  {
    "route": "/for-your-organization",
    "rel": "for-your-organization",
    "pageKey": "for-your-organization",
    "title": "For your organization · behmn",
    "description": "If the work hasn’t changed, the transformation hasn’t happened. We measure the gaps that kill transformations. Then we close them.",
    "robots": null,
    "nav": "organization",
    "bodyClass": "page-organization",
    "css": [
      "for-your-organization",
      "organization-research"
    ],
    "js": [
      "hero-video"
    ],
    "head": null
  },
  {
    "route": "/human-skills-map",
    "rel": "human-skills-map",
    "pageKey": "human-skills-map",
    "title": "The Human Skills Map · behmn",
    "description": "Ten human skills that shape the questions you ask, the decisions you make, how you work with others, and what you get done.",
    "robots": null,
    "nav": "skills-map",
    "bodyClass": "page-skills-map",
    "css": [
      "human-skills-map",
      "hsm-payoff",
      "skills-flow"
    ],
    "js": [
      "hsm",
      "hsm-payoff"
    ],
    "head": null
  },
  {
    "route": "/",
    "rel": "index",
    "pageKey": "home",
    "title": "behmn · the AI reality company",
    "description": "Make your business perform. Make your people better at what they do.",
    "robots": null,
    "nav": null,
    "bodyClass": "page-home",
    "css": [
      "home",
      "hero-video",
      "audience-mobile",
      "team-framing",
      "closing-brand"
    ],
    "js": [
      "home",
      "intro",
      "hero-video",
      "gap-layout"
    ],
    "head": "intro-gate"
  },
  {
    "route": "/join",
    "rel": "join",
    "pageKey": "join",
    "title": "Join behmn",
    "description": "We’re a small senior team and the work ships every month. You’d work directly with the founders, on real clients, from your first week.",
    "robots": null,
    "nav": "join",
    "bodyClass": "",
    "css": [
      "join"
    ],
    "js": [],
    "head": null
  },
  {
    "route": "/reality-gap",
    "rel": "reality-gap",
    "pageKey": "reality-gap",
    "title": "Reality Gap™ · behmn",
    "description": "What leaders say about AI and what’s actually happening are often two different things.",
    "robots": null,
    "nav": "organization",
    "bodyClass": "page-reality-gap",
    "css": [
      "reality-gap"
    ],
    "js": [],
    "head": null
  },
  {
    "route": "/team",
    "rel": "team",
    "pageKey": "team",
    "title": "Team · behmn",
    "description": "Meet Alex Schwartz, Matty Squarzoni and Dr. Ernesto Lee, the people behind behmn.",
    "robots": null,
    "nav": null,
    "bodyClass": "",
    "css": [
      "team"
    ],
    "js": [],
    "head": null
  },
  {
    "route": "/trust",
    "rel": "trust",
    "pageKey": "trust",
    "title": "How we work with your data · behmn",
    "description": "Approved tools, confidential assessment conversations and responsible AI use. How behmn works with your data and your IT team.",
    "robots": null,
    "nav": null,
    "bodyClass": "page-trust",
    "css": [
      "trust"
    ],
    "js": [],
    "head": null
  }
] as const
